module.exports = __webpack_public_path__ + "static/assets/ccc5bfd3fa837a536983adfacace5f2d.gif";